import React from 'react';
import GroupPage from '../../pages/group-page/GroupPage';
import { fetchCompanyMetadata, fetchGroupMetadata } from './GroupContainerService';
import { getMultiRegionCompanyIds } from '../../../utils';
import MultiregionGroupPage from '../../pages/multiregion-group-page/MultiregionGroupPage';

class GroupContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			companyMetadata: null,
			groupMetadata: null,
			regionId: null
		};
	}

	fetchData = async () => {
		const groupId = this.props.match?.params?.groupId || 0;

		const groupMetadata = await fetchGroupMetadata(groupId, this.props.preview);

		if(groupMetadata) {
			const companyMetadata = await fetchCompanyMetadata(groupMetadata.companyId);
			this.setState({ groupMetadata, companyMetadata, regionId: groupMetadata.tabs[0].regionId });
		}
		else {
			this.props.history.push('/');
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	render() {
		if (!this.state.companyMetadata) return <></>;

		const companies = getMultiRegionCompanyIds();
		if (companies.some(x => x === `${this.state.companyMetadata.id}`)) {
			return <MultiregionGroupPage {...this.props} {...this.state} />;
		}
		else {
			return <GroupPage {...this.props} {...this.state} />;
		}
	}
}

export default GroupContainer;
